import { TranslationKey } from './../../../../../../types/translation/TranslationKey';
import React, { useState } from 'react';
import { translate } from '../../../../../../types/translation/Translator';
import { EntityType } from '../../../../../../types/comment';
import { CustomFieldEntityType } from '../../../../../../types/custom_field';
import { OrderTableSettingsColumn } from '../../../../../../types/table_settings/order/OrderTableSettings';
import { OrderProductTransactionTableSettingsColumn } from '../../../../../../types/table_settings/productTransaction/OrderProductTransactionTableSettings';
import TableSettingsView from '../../../../../shared/TableSettings/TableSettingsView';
import DropdownSelect from '../../../../../components/Dropdown/DropdownSelect';

enum OrderTableType {
  order = 'order',
  transaction = 'transaction',
}

function orderTableTypeToString(type: OrderTableType) {
  switch (type) {
    case OrderTableType.order:
      return translate({ key: TranslationKey.order });
    case OrderTableType.transaction:
      return translate({ key: TranslationKey.orderTransaction });
  }
}

export default function OrderTableSettingsPane() {
  const [type, setType] = useState(OrderTableType.order);

  const content = () => {
    switch (type) {
      case OrderTableType.order:
        return (
          <TableSettingsView<OrderTableSettingsColumn>
            type={EntityType.order}
            customFieldEntityType={CustomFieldEntityType.order}
            availableColumns={Object.values(OrderTableSettingsColumn)}
            columnTextBuilder={item => translate({ key: item })}
            label={translate({ key: TranslationKey.addOrderColumn })}
            placeholder={translate({ key: TranslationKey.addOrderColumn })}
          />
        );
      case OrderTableType.transaction:
        return (
          <TableSettingsView<OrderProductTransactionTableSettingsColumn>
            type={EntityType.productTransaction}
            parentType={EntityType.order}
            customFieldEntityType={CustomFieldEntityType.productTransaction}
            availableColumns={Object.values(OrderProductTransactionTableSettingsColumn)}
            columnTextBuilder={item => translate({ key: item })}
            label={translate({ key: TranslationKey.addProductTransactionColumn })}
            placeholder={translate({ key: TranslationKey.addProductTransactionColumn })}
          />
        );
    }
  };

  return (
    <div className='content-x flex h-full flex-grow flex-col gap-6 overflow-auto'>
      <div>
        <DropdownSelect<OrderTableType>
          label={translate({ key: TranslationKey.type })}
          textBuilder={orderTableTypeToString}
          items={Object.values(OrderTableType)}
          itemBuilder={orderTableTypeToString}
          value={type}
          onSelect={item => item && setType(item)}
        />
      </div>
      <div key={type}>{content()}</div>
    </div>
  );
}
